import { toUint8Array } from 'js-base64';
import _ from 'lodash';

import { loginSuccess } from './AuthActions';
import { EXPIRE_TOKEN } from './AuthActions/constants';
import { handleErrors } from './ErrorActions';
import { setUserCacheKey } from '../utils/cacheUtils';
import { generateRandomBuffer, shouldUsePasskeyCredentials } from '../utils/credential.utils';
import { parseBoolean, parseNilOrValue } from '../utils/fns';
import { isNilOrEmpty } from '../utils/ramdaUtils';

export const loginOffline = () => (dispatch) => {
  const token = parseNilOrValue(localStorage.getItem('token'));
  let actorCode = localStorage.getItem('actorCode');
  let actorCodeWithDomain = localStorage.getItem('actorCodeWithDomain');
  const actorFirstName = localStorage.getItem('actorFirstName');
  const actorLastName = localStorage.getItem('actorLastName');
  const licId = localStorage.getItem('licId');
  const loginMethod = localStorage.getItem('loginMethod');
  const username = localStorage.getItem('userFullName');
  const sessionExpirationErrorCode = localStorage.getItem('sessionExpirationErrorCode');
  const sessionExpirationErrorMessage = localStorage.getItem('sessionExpirationErrorMessage');
  const culture = localStorage.getItem('culture');
  const loggedOnRoleCode = localStorage.getItem('loggedOnRoleCode');
  const tokenLifeSpan = localStorage.getItem('tokenLifeSpan');
  const requireRegistration = false;
  const isExternalUser = parseBoolean(localStorage.getItem('isExternalUser'));
  const isArchiveMode = parseBoolean(localStorage.getItem('isArchiveMode'));
  const isArchiveUser = parseBoolean(localStorage.getItem('isArchiveUser'));
  const smartInsightApplicationURL = localStorage.getItem('smartInsightApplicationURL');
  const maxAllowedContentLength = localStorage.getItem('maxAllowedContentLength');

  if (_.isNil(actorCode)) {
    actorCodeWithDomain = localStorage.getItem('prevActorCodeWithDomain');
    actorCode = localStorage.getItem('prevActorCode');
  }

  setUserCacheKey(actorCodeWithDomain);

  dispatch(
    loginSuccess({
      actorCode,
      actorCodeWithDomain,
      culture,
      actorFirstName,
      actorLastName,
      isExternalUser,
      licId,
      loginMethod,
      sessionExpirationErrorCode,
      sessionExpirationErrorMessage,
      requireRegistration,
      token,
      username,
      loggedOnRoleCode,
      isArchiveMode,
      isArchiveUser,
      tokenLifeSpan,
      smartInsightApplicationURL,
      maxAllowedContentLength,
    })
  );

  if (_.isNil(token)) {
    dispatch({ type: EXPIRE_TOKEN });
  }
};

export const checkPasskeyCredentialsIfNeeded = (isOnline) => async (dispatch) => {
  try {
    if (!shouldUsePasskeyCredentials() || isOnline) {
      return;
    }

    const platformAuthAvailable = await window.PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable();

    if (!platformAuthAvailable) {
      dispatch(loginOffline());
      return;
    }

    const passkeyCredentialsId = localStorage.getItem('passkeyCredentialsId');
    const prevActorCodeWithDomain = localStorage.getItem('prevActorCodeWithDomain');
    const currentActorCodeWithDomain = localStorage.getItem('actorCodeWithDomain');

    if (
      _.isNil(prevActorCodeWithDomain) &&
      isNilOrEmpty(passkeyCredentialsId) &&
      _.isNil(currentActorCodeWithDomain)
    ) {
      dispatch(
        handleErrors('Enable and use bio/passcode auth during login', { isTopBanner: true })
      );
      return;
    }

    if (isNilOrEmpty(passkeyCredentialsId)) {
      dispatch(loginOffline());
    }

    const challenge = generateRandomBuffer();

    await navigator.credentials.get({
      publicKey: {
        challenge,
        allowCredentials: [{ type: 'public-key', id: toUint8Array(passkeyCredentialsId) }],
      },
    });

    return dispatch(loginOffline());
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log('checkCredentialsIfNeeded() error: ', error);
  }
};
